<div class="noRecords"
     *ngIf="ResponseModel && ResponseModel.TotalRecords === 0 && !IsSubmitting">
    <span translate>LBL.NO_RECORD_FOUND</span>
</div>
<sk-wave [isRunning]="IsSubmitting"></sk-wave>
<div>
    <div class="row align-items-center no-gutters pagerow flex-nowrap sticky-paginator"
    [ngClass]="AppSettings.IsRunningInSingularity ? 'sticky-paginator-sso' : ''">
        <!-- Sorting -->
        <div ngbDropdown class="">
            <button id="selSort"
                class="btn btn-link btn-nonlink p-0 mr-2"
                ngbDropdownToggle
                title="{{'BTN.BTN_SORT_BY' | translate}}">
                <i class="fas fa-sort mr-2"></i>
                {{SelectedSort | translate}}
            </button>
            <div ngbDropdownMenu aria-labelledby="selSort">
                <button
                    *ngFor="let row of SortParams"
                    class="dropdown-item pointer"
                    [ngClass]="{'active': row.Id == RequestModel.OrderBy}"
                    (click)="OnSortSelected(row)" translate>
                    {{row.Name}}
                </button>
            </div>
        </div>
        <!-- Pagination -->
        <div class="col-auto mr-4"
            *ngIf="ResponseModel && ResponseModel.TotalRecords">
            <ngb-pagination
                [maxSize]="5"
                [rotate]="true"
                [collectionSize]="ResponseModel.TotalRecords"
                [pageSize]="RequestModel.PageSize"
                [(page)]="RequestModel.PageNumber"
                [boundaryLinks]="true"
                (pageChange)="OnPageChange()">
            </ngb-pagination>
        </div>
        <!-- Total Count -->
        <div class="col-auto" *ngIf="ResponseModel && !HideTotalPages">
            <span translate>LBL.TOTAL_RECORDS</span>: <B>{{ResponseModel.TotalRecords}}</B>
        </div>
    </div>
    <!-- Search Result -->
    <div class="row">
        <div class="col">
            <div class="recConsole" *ngIf="!IsSubmitting && ResponseModel && ResponseModel && ResponseModel.TotalRecords">
                <div class="grdGrid">
                    <div *ngFor="let row of ResponseModel.Result"
                         class="grdRow row pointer no-gutters jobdetails"
                         id="jobdetail-{{row.RecurrenceId}}"
                         (keyup.enter)="OnRowSelected(row)"
                         (click)="OnRowSelected(row)"
                         [ngClass]="{'selected': recurrenceService.SelectedRecurrence && row.RecurrenceId == recurrenceService.SelectedRecurrence.RecurrenceId}"
                         tabindex="0">


                            <div class="col-auto grdCol align-items-center">
                                <div class="d-flex">
                                    <div title="{{row.Status}}" class="statusIcon-Standard status-{{row.Status}} mr-2"
                                         [ngClass]="{'border-0': (row.StatusCode == 'D') }"></div>
                                    <div translate>{{row.StatusName}}</div>
                                </div>
                                <div class="ellipsis text-muted small ml-4"
                                     title="{{('TITLE.TITLE_FREQUENCY' | translate) + ' - '+ row._RecurrenceFrequency}}">{{row._RecurrencePattern}}</div>
                            </div>
                            <div class="col-auto grdCol"
                                 title="{{'TITLE.TITLE_JOB_DESCR' | translate}}">{{row.CallDescription}}&nbsp;
                            </div>
                            <div class="col-auto grdCol">
                                <div class="ellipsis"
                                     title="{{('TITLE.TITLE_LOCATION' | translate) +' - '+row.Location}}"><i
                                    class="fas fa-map-marker-alt"></i> {{row.Location}}</div>
                                <div class="text-muted small"
                                     title="{{'TITLE.TITLE_ROOM_STATUS' | translate}}">{{row._RoomStatus}}</div>
                            </div>
                            <div class="col-auto grdCol">
                                <div class="ellipsis"
                                     title="{{('TITLE.TITLE_DEPARTMENTS' | translate) +' - '+ row.Department}}">{{row.Department}}</div>
                                <div class="text-muted small"
                                     *ngIf="masterService.LoggedInUserData.Properties.length > 1"
                                     title="{{'TITLE.TITLE_PROPERTY' | translate}} - {{row.PropertyName}}"><i
                                    class="fas fa-building"></i> {{row.PropertyCode}}</div>
                            </div>
                            <div class="col-auto grdCol">
                                <div class="ellipsis" [ngSwitch]="row.StatusCode">
                                    <span *ngSwitchCase="'Y'" [hidden]="!row.ReopenDateTime"><span translate>LBL.NEXT_RUN_ON</span> {{row.ReopenDateTime | PropertyDateTimeFormatPipe: row.PropertyId }}</span>
                                    <span *ngSwitchCase="'N'" [hidden]="!row.EndDateTime"><span
                                        translate>LBL.EXPIRED_ON</span> {{row.EndDateTime | PropertyDateTimeFormatPipe: row.PropertyId  }}</span>
                                    <span *ngSwitchCase="'D'" [hidden]="!row.LastUpdateTime"><span translate>LBL.DELETED_ON</span> {{row.LastUpdateTime | PropertyDateTimeFormatPipe: row.PropertyId }}</span>
                                </div>
                                <div class="text-muted small"
                                     title="{{'TITLE.TITLE_PATTERN' | translate}}">{{row._EndPattern}}</div>
                            </div>
                            <div class="col-md grdCol ellipsis linebreak" title="{{row.Comments}}"
                                 data-html="true">{{row.Comments}}</div>
                            <div class="col-auto grdCol pr-4 d-flex align-items-center">
                                <i title="{{'ICON_DEF.ICON_DEF_WORKORDER' | translate}}" class="kmt-icons text-danger kmt-icon-construction" *ngIf="row.ComplainType == 4"></i>
                            </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
